import axiosInstance from './axiosConfig';

/** Note colours, shared by the cards, the editor and the folder chips. */
export const NOTE_COLORS = ['default', 'blue', 'green', 'violet', 'red', 'amber', 'teal', 'slate'];

/** CSS values for each colour, in light and dark mode. */
export const NOTE_COLOR_STYLES = {
  default: { light: '#ffffff', dark: '#1f2937' },
  blue: { light: '#e8f0fe', dark: '#1e3a5f' },
  green: { light: '#e6f4ea', dark: '#14532d' },
  violet: { light: '#f3e8fd', dark: '#4c1d95' },
  red: { light: '#fce8e6', dark: '#7f1d1d' },
  amber: { light: '#fef7e0', dark: '#78350f' },
  teal: { light: '#e0f2f1', dark: '#134e4a' },
  slate: { light: '#eceff1', dark: '#334155' },
};

/** Client for the ATOZAS Notes backend (/api/notes/*). */
export const notesApi = {
  list: (params = {}) => axiosInstance.get('/api/notes', { params }).then((r) => r.data),
  create: (payload) => axiosInstance.post('/api/notes', payload).then((r) => r.data),
  update: (id, payload) => axiosInstance.put(`/api/notes/${id}`, payload).then((r) => r.data),
  /** Partial update for inline actions such as pinning or ticking an item. */
  patch: (id, payload) => axiosInstance.patch(`/api/notes/${id}`, payload).then((r) => r.data),
  trash: (id) => axiosInstance.post(`/api/notes/${id}/trash`).then((r) => r.data),
  restore: (id) => axiosInstance.post(`/api/notes/${id}/restore`).then((r) => r.data),
  remove: (id) => axiosInstance.delete(`/api/notes/${id}`).then((r) => r.data),

  listFolders: () => axiosInstance.get('/api/notes/folders').then((r) => r.data),
  createFolder: (payload) => axiosInstance.post('/api/notes/folders', payload).then((r) => r.data),
  updateFolder: (id, payload) =>
    axiosInstance.put(`/api/notes/folders/${id}`, payload).then((r) => r.data),
  removeFolder: (id) => axiosInstance.delete(`/api/notes/folders/${id}`).then((r) => r.data),

  dueReminders: () => axiosInstance.get('/api/notes/reminders').then((r) => r.data),
};

export default notesApi;
